import { createContext } from 'react';
import { AddProjectContextProps } from '../types/types';

export const AddProjectContext = createContext<AddProjectContextProps>(
    {} as AddProjectContextProps
);
